/* 🤖 this file was generated by svg-to-ts */
export const matIconWarningAmber: {
  name: 'warning-amber';
  data: string;
} = {
  name: 'warning-amber',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"/></svg>`
};
